import { useEffect, useRef } from "react"
import * as THREE from "three"

import gsap, { Sine } from "gsap"
import { useTexture } from "@react-three/drei"
import { useThree } from "@react-three/fiber"

type TProps = {
  renamed: string
  floor: string
  hasLimit?: boolean
  callback?: () => void
  initialPosition: [number, number, number]
}
function Sphere({
  renamed,
  floor,
  hasLimit,
  callback,
  initialPosition,
}: TProps) {
  const matRef = useRef<THREE.MeshBasicMaterial>()

  const mainTexture = useTexture(`/assets/imgs/views/${renamed}_${floor}m.jpg`)

  mainTexture.minFilter = THREE.LinearFilter
  mainTexture.wrapS = THREE.RepeatWrapping
  mainTexture.repeat.x = -1

  useEffect(() => {
    gsap.to(matRef.current, {
      duration: 1,
      opacity: 1,
      ease: Sine.easeInOut,
    })
  }, [])

  return (
    <mesh visible position={[0, 0, 0]} rotation={initialPosition}>
      <sphereGeometry args={[800, 60, 40]} />
      <meshBasicMaterial
        toneMapped={false}
        map={mainTexture}
        side={THREE.BackSide}
        ref={matRef}
        opacity={0}
        transparent
      />
    </mesh>
  )
}

export default Sphere
